module.exports = __webpack_public_path__ + "847c1e969e79f367a31a386df337a488.png";


//////////////////
// WEBPACK FOOTER
// ./components/atoms/logo.png
// module id = 6YZg
// module chunks = 10